import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import router from '@/mobile/src/router'
import PageHeader from '@/mobile/src/components/appV4/headers/PageHeader.vue'
import { FontAwesomeIcon } from 'fontawesome/vue-fontawesome'
import { faChevronLeft } from 'fontawesome/free-solid-svg-icons'


export default /*#__PURE__*/_defineComponent({
  __name: 'BackHeader',
  setup(__props) {

function goBack() {
    router.back()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PageHeader, {
    key: "header",
    class: "header",
    "go-back": goBack
  }, {
    back: _withCtx(() => [
      _createVNode(_unref(FontAwesomeIcon), {
        class: "back",
        size: "lg",
        icon: _unref(faChevronLeft)
      }, null, 8, ["icon"])
    ]),
    action: _withCtx(() => []),
    _: 1
  }))
}
}

})